import { Group } from "typings";
import produce from "immer";
import { ServerState } from "../ServerState";
import { GroupActions } from "./action";


export interface State extends ServerState<Group>
{
}

const initialState: State = {
    byId: {}
};


const reducer = (state = initialState, action: GroupActions): State => produce(state, draft =>
{
    if (action.type === "LOAD_GROUPS_SUCCESS")
    {
        const { groups } = action;
        for (const group of groups)
        {
            draft.byId[group.groupName] = group;
        }
    }
});

export const getGroups = (state: State): Group[] => Object.keys(state.byId).map(key => state.byId[key]);


export default reducer;


// WEBPACK FOOTER //
// ./src/state/group/index.ts